"use client";

import { ArrowRight } from "lucide-react";

export default function ProcessFlowchart({ title, titleIcon, titleIconClassName, steps, footer, borderClassName = "border-gray-200" }) {
  return (
    <div className={`bg-white rounded-lg p-4 border ${borderClassName}`}>
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
        <span className={titleIconClassName}>{titleIcon}</span>
        {title}
      </h3>

      <div className="relative">
        <div className="hidden md:flex flex-col gap-4">
          {steps.map((step, index) => (
            <div key={step.id} className="flex items-center gap-4">
              <div className={`flex-1 ${step.color} text-white rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow`}>
                <div className="flex items-center gap-3">
                  <div className="bg-white/20 rounded-full p-2">{step.icon}</div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="bg-white/30 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">{step.id}</span>
                      <h4 className="font-semibold text-sm">{step.title}</h4>
                    </div>
                    <p className="text-xs text-white/90">{step.description}</p>
                  </div>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="flex flex-col items-center">
                  <ArrowRight className="h-6 w-6 text-gray-400" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="md:hidden space-y-4">
          {steps.map((step, index) => (
            <div key={step.id}>
              <div className={`${step.color} text-white rounded-lg p-4 shadow-md`}>
                <div className="flex items-center gap-3">
                  <div className="bg-white/20 rounded-full p-2">{step.icon}</div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="bg-white/30 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">{step.id}</span>
                      <h4 className="font-semibold text-sm">{step.title}</h4>
                    </div>
                    <p className="text-xs text-white/90">{step.description}</p>
                  </div>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="flex justify-center my-2">
                  <ArrowRight className="h-5 w-5 text-gray-400 rotate-90" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {footer}
    </div>
  );
}
